exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".all-partners-toggle{display:flex;align-items:center}.all-partners-toggle span{margin-left:.2em;font-size:.75em}.navigation-wrapper{display:flex;flex-direction:row;justify-content:space-between;margin-top:1rem}.preset-wrapper{position:relative;display:flex;justify-content:flex-end}", ""]);

// exports
